import { useGLTF } from "@react-three/drei";

export default function JawModel({onSelectTooth}) {

  const { scene } = useGLTF("/models/jaw.glb");

  scene.traverse((child) => {

    if(child.isMesh){

      child.onClick = (e) => {

        e.stopPropagation();

        onSelectTooth(child.name);

      };

    }

  });

  return <primitive object={scene} scale={2} />;
}